<script>
   import {emeters, integrated_list } from "../stores";
</script>

{#if $integrated_list.length > 0}
    <section>
        <h3>Use following id(s) to register your device(s) in Wattics</h3>

        {#each $integrated_list as id}
        {#if $emeters.find(el => el.id === id)}
            <div class="wattics_ids">
                <span>{`${$emeters.find((el) => el.id === id)?.name}`}</span>
                <span class="user_select" style={"color: cyan"}>{`shelly_${id}`}</span>
            </div>
        {/if}
        {/each}
    </section>
{:else}
    <h3>You are not subscribed for Shelly integration with Wattics!</h3>
{/if}

<style>
    section {
        display: flex;
        position: absolute;
        top: 15%;
        left: var(--display-main_content_left);

        height: var(--display-main_content_height);
        width: var(--display-main_content_width);
       
        align-items: center;
        flex-direction: column;
        overflow-y: auto;
        scrollbar-width: thin;
        scrollbar-color: var(--color_scheme-contrast_color) #555;

        /* border-left: 1px solid var(--color_scheme-contrast_color);
        border-right: 1px solid var(--color_scheme-contrast_color); */
    }
    h3{
        overflow-wrap: break-word;
    }
    .user_select { 
        -moz-user-select: text;
        -webkit-user-select: text;
        -ms-user-select: text;
        user-select: text;
    }
    .wattics_ids {
        display: flex;
        width: var(--display-single_select_width);
        min-height: 30px;
        height: 10%;
        flex-wrap: wrap;
        justify-content: space-between;
        align-items: flex-end;
        margin-bottom: 1px;
        box-sizing: border-box;
    }

    ::-webkit-scrollbar {
        width: 0.15em;
    }

    ::-webkit-scrollbar-track {
        background: #f1f1f1;
    }

    ::-webkit-scrollbar-thumb {
        background: var(--color_scheme-contrast_color);
    }

    ::-webkit-scrollbar-thumb:hover {
        background: #555;
    }
</style>
